import {Component, OnInit} from '@angular/core';
import {CpProvisionAgentBaseComponent} from '../base/cp-provision-agent-base.component';

/**
 * Full view of the ProvisionAgent OBC (`uiMode = 'full'`, layer 2 of PAT §L.2).
 *
 * Original: `bm-billing-area-full.component.ts` — the component inherits the `navigationItems` from
 * {@link CpProvisionAgentBaseComponent} and renders exactly ONE shared detail component per active
 * navigation item. It contains NO business logic and NO form HTML itself.
 */
@Component({
    selector: 'cp-provision-agent-full',
    templateUrl: './cp-provision-agent-full.component.html',
    styleUrls: ['./cp-provision-agent-full.component.scss'],
    standalone: false
})
export class CpProvisionAgentFullComponent extends CpProvisionAgentBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
